<template>
    <div
        class="loading d-flex justify-content-center align-items-center flex-column"
    >
        <div
            class="loading-content d-inline-flex justify-content-center align-items-center"
        >
            <b-spinner label="Spinning" small class="mr-2"></b-spinner>
            Loading...
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Loading',
};
</script>

<style lang="scss" scoped>
@import 'Loading';
</style>
